module.exports = __webpack_public_path__ + "img/stx.5eaedc26.svg";